import { ColumnConfig } from '@/components/table/Table';
import { UserStatus, UserStatusLabels } from '../enums';
import { USER_STATUS_CHIP_COLORS } from './statusChip';
import type { UserApi } from '../models';
import { formatUserPhone } from '../utils/formatUserPhone';
import {
  getUserAssignments,
  getUserTypeLabel,
} from '../utils/userAssignments';

const assignmentChipClass =
  'px-2 py-0.5 rounded-md text-xs font-medium bg-gray-100 text-gray-700';

const renderNameList = (names: string[], allLabel: string, includeAll: boolean) => {
  if (includeAll) {
    return (
      <span className={assignmentChipClass}>{allLabel}</span>
    );
  }
  if (names.length === 0) return null;
  return names.map((name) => (
    <span key={name} className={assignmentChipClass}>
      {name}
    </span>
  ));
};

export const usersTableColumns: ColumnConfig[] = [
  {
    label: 'Nombre',
    field: 'firstName',
    render: (value: string) => value || '______',
  },
  {
    label: 'Apellido',
    field: 'lastName',
    render: (value: string) => value || '______',
  },
  {
    label: 'Teléfono',
    field: 'phoneNumber',
    render: (value: string) => formatUserPhone(value),
  },
  {
    label: 'Email',
    field: 'email',
    render: (value: string) => value || '______',
  },
  {
    label: 'Tipo',
    field: 'userType',
    render: (_value: unknown, row: UserApi) => getUserTypeLabel(row),
  },
  {
    label: 'Asignaciones',
    field: 'assignments',
    render: (_value: unknown, row: UserApi) => {
      const {
        operators,
        commerces,
        includeAllOperators,
        includeAllCommerces,
      } = getUserAssignments(row);

      const operatorChips = renderNameList(
        operators,
        'Todos los operadores',
        includeAllOperators
      );
      const commerceChips = renderNameList(
        commerces,
        'Todos los comercios',
        includeAllCommerces
      );

      if (!operatorChips && !commerceChips) {
        return '—';
      }

      return (
        <div className='flex flex-col gap-1.5 min-w-[12rem]'>
          {operatorChips && (
            <div className='flex flex-col gap-0.5'>
              <span className='text-[11px] font-semibold uppercase tracking-wide text-gray-400'>
                Operadores
              </span>
              <div className='flex flex-wrap gap-1'>{operatorChips}</div>
            </div>
          )}
          {commerceChips && (
            <div className='flex flex-col gap-0.5'>
              <span className='text-[11px] font-semibold uppercase tracking-wide text-gray-400'>
                Comercios
              </span>
              <div className='flex flex-wrap gap-1'>{commerceChips}</div>
            </div>
          )}
        </div>
      );
    },
  },
  {
    label: 'Estado',
    field: 'status',
    render: (value: string | undefined) => {
      const label = value ? UserStatusLabels[value as UserStatus] || value : '—';
      const chipClass = value ? USER_STATUS_CHIP_COLORS[value] : undefined;
      return chipClass ? (
        <span className={`px-3 py-1 rounded-md text-sm font-semibold ${chipClass}`}>
          {label}
        </span>
      ) : (
        <>{label}</>
      );
    },
  },
];
